import classes from './TextCell.module.css'
import classesCell from './BodyCell.module.css'
import Button from '../../common/Button'
import WorkQDeferredTooltip from './WorkQDeferredTooltip'

export default function TextCellCopy({text, item}) {
    function copyTextHandler() {
        let htmlToCopy = text

        navigator.clipboard.writeText(htmlToCopy)
    }

    return <div className={`${classes.text_cell} ${classesCell.body_cell}`}>
        {/* <Button title='copy person #' click={copyTextHandler} btnStyle={'btn_simple'}><i className="ti ti-copy"></i></Button> {text} */}

        {!item?.case?.chart_numbers && <div className={classes.wrapper}>
            <Button title='copy person #' click={copyTextHandler} btnStyle={'btn_simple'}><i className="ti ti-copy"></i></Button> {text}
        </div>}

        {item?.case?.chart_numbers && <WorkQDeferredTooltip normalEvent={true} messages={[item.case.chart_numbers]} >
            <div className={classes.wrapper}>
                <Button title='copy person #' click={copyTextHandler} btnStyle={'btn_simple'}><i className="ti ti-copy"></i></Button> {text}
            </div>
        </WorkQDeferredTooltip>}
    </div>
}